import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Pagination from '../../components/pagination';
import SvgExportIcon from '../../icons/svgExportIcon';
import SvgDropdown from '../../icons/svgDropdown';
import AssetConfig from '../../components/assetconfig';
import Modal from '../../components/modal';
import ExportHistoryModal from './exporthistorymodal';
import { months, getFullYearsArray } from './utility';
import 'react-dates/lib/css/_datepicker.css';
import Recaptcha from 'react-google-recaptcha';
import moment from 'moment';

import {
  fetchHistory,
  fetchSubHistory,
  fetchOrderHistory,
  fetchLedger,
  exportHistory,
  requestGenerateStatement,
  getAutomationLogs,
} from '../../actions';

const qs = require('query-string');
const dateFormat = 'DD/MMM/YYYY LT';

class History extends Component {
  constructor(props) {
    super(props);
    const filterParams = qs.parse(this.props.location.search)
    this.state = {
      recaptchaRef: React.createRef(),
      modalComponent: null,
      historyPairs: {},
      otcAssets: [],
      currentPage: 1,
      filterParams,
      focusedInput: null,
      allSubHistory: [],
      exported: false,
      statement: false,
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      loading: true,
      pairA: 'GOLD',
      pairB: 'BTC',
      focusedRange: [0, 0],
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.addressRef = [];
    this.setCurrentPage = this.setCurrentPage.bind(this);
    this.calendarActions = this.calendarActions.bind(this);
    this.showCalendar = this.showCalendar.bind(this);
    this.clearDates = this.clearDates.bind(this);
    this.tableHeadings = this.tableHeadings.bind(this);
    this.subTableHeadings = this.subTableHeadings.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.updateData = this.updateData.bind(this);
    this.exportData = this.exportData.bind(this);
    this.changeHistoryView = this.changeHistoryView.bind(this);
    this.copyConfirm = this.copyConfirm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.returnYears = this.returnYears.bind(this);
    this.isOfType = this.isOfType.bind(this);
    this.handleSplitPair = this.handleSplitPair.bind(this);
    this.handlePair = this.handlePair.bind(this);
    this.generateStatement = this.generateStatement.bind(this);
    this.onSubmitWithReCAPTCHA = this.onSubmitWithReCAPTCHA.bind(this);
  }

  async onSubmitWithReCAPTCHA() {
    const token = await this.state.recaptchaRef.current.executeAsync();
  }

  componentDidMount() {
    const { filterParams } = this.state;
    this.assetsInitial();
    if (filterParams && filterParams.view) {
      this.changeHistoryView(filterParams.view);
    } else {
      this.changeHistoryView();
    }
  }

  toggleModal(component) {
    this.setState({
      modalComponent: component,
    });
  }

  assetsInitial() {
    const { assets, pairs } = this.props;
    const { exchA, fiatEnabled } = this.state;

    const historyPairs = {};
    const assetPairs = [];
    let allAssets = [];
    let uniqueAssets = [];
    const frontEnabled = [];
    let useAssets = [];
    if (pairs && Object.keys(pairs).length) {
      Object.keys(pairs).forEach((key) => {
        if (pairs[key] && pairs[key].permissions) {
          if (pairs[key].permissions.includes('HISTORY')) {
            historyPairs[key] = pairs[key];
          }
        }
      });
    }
    if (historyPairs && Object.keys(historyPairs).length) {
      Object.keys(historyPairs).forEach((key) => {
        if (historyPairs[key] && historyPairs[key].alt) {
          assetPairs.push(historyPairs[key].alt.split(':'));
        }
      });
      allAssets = [].concat.apply([], assetPairs);
      uniqueAssets = [...new Set(allAssets)];
    }
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          frontEnabled.push(asset.handle);
        }
      });
    }
    if ((uniqueAssets && uniqueAssets.length) && (frontEnabled && frontEnabled.length)) {
      useAssets = uniqueAssets.filter((asset) => {
        return frontEnabled.includes(asset);
      });
    }

    let otcAssets;
    let aAssets;
    let bAssets;
    if ((assets && assets.length) && (useAssets && useAssets.length)) {
      otcAssets = assets
        .filter((asset) => {
          return useAssets.includes(asset.handle);
        })
        .map((asset) => {
          return (
            {
              name: asset.name.toUpperCase(),
              asset: asset.handle,
              defaults: asset.defaults,
            }
          );
        });
    }

    if (otcAssets && otcAssets.length) {
      aAssets = [...otcAssets];
      bAssets = [...otcAssets];
    }

    if (aAssets && bAssets) {
      this.setState({ historyPairs, otcAssets, aAssets, bAssets });
    }
  }

  setCurrentPage(number) {
    const { currentPage } = this.state;
    if (currentPage !== number) {
      this.setState({
        currentPage: number,
      });
      this.updateData(number);
    }
  }

  changeHistoryView(newView) {
    const { user, showPair, showAsset } = this.props;
    const { filterParams } = this.state;

    this.setState({ loading: true });

    let defaultPair;
    if (user && user.me && user.me.defaults && user.me.defaults.pair) {
      defaultPair = user.me.defaults.pair;
    }

    if (newView) {
      if (filterParams.view !== newView) {
        filterParams['view'] = newView;
        delete filterParams['since'];
        delete filterParams['until'];
        delete filterParams['asset'];
        delete filterParams['type'];
        delete filterParams['pair'];
        delete filterParams['status'];
      } else {
        filterParams['view'] = newView;
      }
    }
    let field;
    if (!filterParams.view || filterParams.view === 'transactions') {
      if (!filterParams.handle) {
        field = 'handle';
        filterParams[field] = 'BTC';
      }
    }
    if (filterParams.view === 'trades' || filterParams.view === 'trades-v2') {
      // if (!filterParams.exchange) {
      //   field = 'exchange';
      //   filterParams[field] = defaultPair || 'GOLDBTC';
      // }
      filterParams['exchange'] = 'GOLDBTC';
      filterParams['pairA'] = 'GOLD';
      filterParams['pairB'] = 'BTC';
      this.setState({pairA: 'GOLD', pairB: 'BTC'})
    }
    if (filterParams.view === 'orders' || filterParams.view === 'orders-v2') {
      // if (!filterParams.exchange) {
      //   field = 'exchange';
      //   filterParams[field] = defaultPair || 'GOLDBTC';
      // }
      filterParams['exchange'] = 'GOLDBTC';
      filterParams['pairA'] = 'GOLD';
      filterParams['pairB'] = 'BTC';
      this.setState({pairA: 'GOLD', pairB: 'BTC'})
    }

    if (!filterParams.exchange || !showPair(filterParams.exchange)) {
      filterParams.exchange = defaultPair || 'GOLDBTC';
    }

    if (!filterParams.handle || !showAsset(filterParams.handle)) {
      filterParams.handle = 'GOLD';
    }

    if (filterParams.view === 'ledger' && newView) {
      delete filterParams['handle']
    }

    this.setState({ filterParams });
    this.props.history.push({ search: '?' + qs.stringify(filterParams) });
    this.updateData();
  }

  updateData(page, newParams) {
    const { dispatch } = this.props;
    let { filterParams } = this.state;
    let useParams = filterParams;
    if (newParams) {
      useParams = newParams;
    }
    let data;
    let type;
    if (!useParams.view || useParams.view === 'transactions' || useParams.view === 'transactions-v2') {
      type = 'transactions';
      data = {
        fx: true,
        since: filterParams.startDate,
        until: filterParams.endDate,
        asset: filterParams.handle,
        type: filterParams.type,
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'ledger') {
      type = 'ledger';
      data = {
        // fx: true,
        since: useParams.startDate,
        until: useParams.endDate,
        handle: useParams.handle,
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'trades' || useParams.view === 'trades-v2') {
      type = 'trades';
      data = {
        fx: true,
        since: useParams.startDate,
        until: useParams.endDate,
        pair: useParams.exchange,
        type: useParams.type,
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'transfers' || useParams.view === 'transfers-v2') {
      type = 'fees';
      data = {
        fx: true,
        since: useParams.startDate,
        until: useParams.endDate,
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'orders' || useParams.view === 'orders-v2') {
      type = 'orders';
      data = {
        fx: true,
        // since: useParams.startDate,
        // until: useParams.endDate,
        type: useParams.type,
        pair: useParams.exchange,
        status: useParams.status,
        self: true,
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'automations') {
      type = 'automations';
      data = {
        page: 1,
      };
      if (page) {
        data.page = page;
      }
    }
    if (useParams.view === 'statements') {
      this.setState({ exported: false, loading: false });
      return;
    }
    if (useParams.view === 'orders') {
      dispatch(fetchOrderHistory(data)).then((res) => {
        if (res.type === 'FETCH_ORDER_HISTORY_SUCCESS') {
          this.setState({ loading: false });
        }
      });
    } else if (useParams.view === 'ledger') {
      dispatch(fetchLedger(data)).then((res) => {
        if (res.type === 'FETCH_LEDGER_SUCCESS') {
          this.setState({ loading: false });
        }
      });
    } else if (useParams.view === 'automations') {
      dispatch(getAutomationLogs(data)).then((res) => {
        if (res.type === 'GET_AUTOMATION_LOGS_SUCCESS') {
          this.setState({ loading: false });
        }
      });
    } else {
      dispatch(fetchHistory(data, type)).then((res) => {
        if (res.type === 'FETCH_HISTORY_SUCCESS') {
          this.setState({ loading: false });
        }
      });
    }
    this.setState({ exported: false });
  }

  exportData() {
    const { dispatch } = this.props;
    let { filterParams } = this.state;
    let type;
    if (!filterParams.view || filterParams.view === 'transactions') {
      type = 'transactions';
    }
    if (filterParams.view === 'ledger') {
      type = 'ledger';
    }
    if (filterParams.view === 'trades' || filterParams.view === 'trades-v2') {
      type = 'trades';
    }
    if (filterParams.view === 'orders' || filterParams.view === 'orders-v2') {
      type = 'orders';
    }
    if (filterParams.view === 'transfers' || filterParams.view === 'transfers-v2') {
      type = 'fees';
    }
    const data = {
      type,
      pair: filterParams.exchange,
      asset: filterParams.handle,
      since: filterParams.startDate,
      until: filterParams.endDate,
    };
    dispatch(exportHistory(data))
      .then((res) => {
        if (res.type === 'EXPORT_HISTORY_SUCCESS') {
          this.setState({ exported: true });
          this.toggleModal(null);
        }
      });
  }

  toggleAutomationSub(itemState, refId) {
    this.setState({ [itemState]: !this.state[itemState] });
  }

  toggleOrderSub(itemState, refId) {
    const { dispatch } = this.props;
    const { filterParams, allSubHistory } = this.state;

    const data = {
      fx: true,
      asset: filterParams.handle,
      type: filterParams.type,
      since: filterParams.startDate,
      until: filterParams.endDate,
      pair: filterParams.exchange,
      orderId: refId,
    };

    if (!this.state[itemState]) {
      dispatch(fetchSubHistory(data, 'trades'))
        .then(res => {
          let merged = [...allSubHistory, ...res.payload.data];
          let filteredArr;
          if (merged) {
            filteredArr = merged.reduce((acc, current) => {
              const x = acc.find(item => item.referenceId === current.referenceId);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);
          }
          this.setState({ allSubHistory: filteredArr });
        });
    }

    this.setState({ [itemState]: !this.state[itemState] });
  }

  handleChange(event, field) {
    const { history } = this.props;
    let { filterParams } = this.state;

    const { value } = event.target;

    if (value) {
      if (field === 'view') {
        this.changeHistoryView(value);
        return;
      }
      if (
        (field === 'type' && value === 'ALL')
        || (field === 'status' && value === 'ANY')
        || (field === 'handle' && value === 'ALL')
      ) {
        delete filterParams[field];
      } else {
        filterParams[field] = value;
      }
    } else {
      delete filterParams[field];
    }

    this.setState({ filterParams });
    history.push({ search: '?' + qs.stringify(filterParams) });
    this.updateData();
  }

  handleDateChange(dates) {
    let { filterParams, focusedInput } = this.state;
    let field;

    if (focusedInput === 'startDate') {
      field = 'startDate';
      filterParams[field] = moment(dates.startDate).unix();
      this.setState({ filterParams, focusedInput: 'endDate' });
    }

    if (focusedInput === 'endDate') {
      field = 'endDate';
      filterParams[field] = moment(dates.endDate).unix();
      this.setState({ filterParams, focusedInput: 'startDate' });
    }

    this.props.history.push({ search: '?' + qs.stringify(filterParams) });
    this.updateData();
  }

  clearDates() {
    let { filterParams } = this.state;
    delete filterParams.startDate;
    delete filterParams.endDate;
    this.setState({ filterParams, focusedInput: 'startDate' });
    this.props.history.push({ search: '?' + qs.stringify(filterParams) });
    this.updateData();
  }

  returnYears() {
    let years = []
    for(let i = moment().year() - 100; i <= moment().year(); i++) {
      years.push(<option value={i}>{i}</option>);
    }
    return years;
  }

  calendarActions() {
    return (
      <div className="calendar-actions">
        <button type="button" className="button" onClick={() => this.clearDates(null)}>
          <span>Clear</span>
        </button>
        <button type="button" className="button" onClick={() => this.setState({ focusedInput: null })}>
          <span>Close</span>
        </button>
      </div>
    );
  }

  showCalendar() {
    const { filterParams, focusedInput } = this.state;

    let startDate;
    let endDate;

    if (filterParams.startDate) {
      startDate = moment.unix(filterParams.startDate, dateFormat);
    }
    if (filterParams.endDate) {
      endDate = moment.unix(filterParams.endDate, dateFormat);
    }

    const isCalendar = focusedInput || (startDate || endDate);

    return (
      <div>
        { !isCalendar && (
          <div
            className="f-time"
            id="Time"
            role="button"
            tabIndex={0}
            onKeyPress={() => this.setState({ focusedInput: 'startDate' })}
            onClick={() => this.setState({ focusedInput: 'startDate' })}
          >
            <span>Date Filter</span>
          </div>
        )}
        { isCalendar && (
          <DateRangePicker
            startDate={startDate}
            startDateId="startDate"
            endDate={endDate}
            endDateId="endDate"
            onDatesChange={this.handleDateChange}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
            numberOfMonths={1}
            keepOpenOnDateSelect
            hideKeyboardShortcutsPanel
            // block={true}
            // verticalSpacing={10}
            // calendarInfoPosition="top"
            // showClearDates={true}
            customArrowIcon={String.fromCharCode(9656)}
            calendarInfoPosition="bottom"
            renderCalendarInfo={this.calendarActions}
            daySize={40}
            isOutsideRange={() => false}
            renderMonthElement={({ month, onMonthSelect, onYearSelect }) => (
              <div className="cal-month-el">
                <div>
                  <select
                    value={month.month()}
                    onChange={(e) => onMonthSelect(month, e.target.value)}
                  >
                    {moment.months().map((label, value) => (
                      <option value={value} key={value}>{label}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
                    {this.returnYears()}
                  </select>
                </div>
              </div>
            )}
          />
        )}
      </div>
    );
  }

  humName(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => item.handle === asset);
    }
    let name;
    if (assetData) {
      name = assetData.name.toUpperCase();
    }
    return name;
  }

  tableHeadings() {
    const { filterParams } = this.state;
    const { getPairAssets } = this.props;

    let tokenType;
    let volumeType;
    // let currencyType;
    let exchangeRate;
    let pairAssets;

    if (filterParams.handle) {
      tokenType = this.humName(filterParams.handle);
    }

    if (filterParams.exchange) {
      pairAssets = getPairAssets(filterParams.exchange);
      if (pairAssets && pairAssets.exchA && pairAssets.exchB) {
        volumeType = pairAssets.exchA;
        // currencyType = this.humName(pairAssets.exchB);
        exchangeRate = this.humName(pairAssets.exchA) + ' / ' + this.humName(pairAssets.exchB);
      }
    }

    if (filterParams.view === 'trades') {
      return (
        <div className="hl-head">
          <div>Order Type</div>
          <div>Date (UTC)</div>
          <div>Volume ({volumeType})</div>
          {/* <div>Currency ({currencyType})</div> */}
          <div>Price ({exchangeRate})</div>
          <div>Fee</div>
          <div>Status</div>
        </div>
      );
    }
    if (filterParams.view === 'trades-v2') {
      return (
        <div className="hl-head">
          <div>Order ID</div>
          <div>Executed @</div>
          <div>Pair</div>
          <div>Price</div>
          <div>Volume</div>
          <div>Cost</div>
          <div>Fee Paid / Earned</div>
          <div>Maker / Taker</div>
          <div>Order Type</div>
        </div>
      );
    }
    if (filterParams.view === 'orders') {
      return (
        <div className="hl-head">
          <div>Status</div>
          <div>Opened (UTC)</div>
          <div>Updated (UTC)</div>
          <div>Initial Volume ({volumeType})</div>
          <div>Remaining Volume ({volumeType})</div>
          <div>Price ({exchangeRate})</div>
          <div>Order Type</div>
          <div>Match Type</div>
          <div>Trades</div>
        </div>
      );
    }
    if (filterParams.view === 'orders-v2') {
      return (
        <div className="hl-head">
          <div>Order ID</div>
          <div>Closed @</div>
          <div>Pair</div>
          <div>Price</div>
          <div>Avg. Price</div>
          <div>{`Volume Exec'd`}</div>
          <div>Cost</div>
          <div>Order Type</div>
          <div>Status</div>
        </div>
      );
    }
    if (filterParams.view === 'transfers') {
      return (
        <div className="hl-head">
          <div>Date (UTC)</div>
          <div>Type</div>
          <div>Status</div>
          <div>Amount</div>
          <div className="hl-i-inf-desc">Description</div>
        </div>
      );
    }
    if (filterParams.view === 'transfers-v2') {
      return (
        <div className="hl-head">
          <div>Date (UTC)</div>
          <div>Type</div>
          <div>Status</div>
          <div>Amount</div>
          <div className="hl-i-inf-desc">Description</div>
        </div>
      );
    }
    if (filterParams.view === 'ledger') {
      return (
        <div className="hl-head">
          <div>Ledger ID</div>
          <div>Date</div>
          <div>Timestamp</div>
          <div>Type</div>
          <div>Currency</div>
          <div>Amount</div>
          <div>Balance</div>
        </div>
      );
    }
    if (filterParams.view === 'statements') {
      return (
        <div className="hl-head">
          <div>Statement</div>
          <div></div>
        </div>
      );
    }
    if (filterParams.view === 'automations') {
      return (
        <div className="hl-head">
          <div>Flow ID</div>
          <div>Reference ID</div>
          <div>Created At</div>
          <div>Deposit Asset</div>
          <div>Trades</div>
        </div>
      )
    }
    return (
      <div className="hl-head">
        <div>Type</div>
        <div>Note</div>
        <div>Reference ID</div>
        <div>Date (UTC)</div>
        <div>Amount ({tokenType})</div>
        <div>Status</div>
        <div>Transaction ID</div>
        <div>Details</div>
      </div>
    );
  }

  subTableHeadings() {
    const { filterParams } = this.state;
    const { getPairAssets } = this.props;

    let volumeType;
    // let currencyType;
    let exchangeRate;
    let pairAssets;

    if (filterParams.exchange) {
      pairAssets = getPairAssets(filterParams.exchange);
      if (pairAssets && pairAssets.exchA && pairAssets.exchB) {
        volumeType = pairAssets.exchA;
        // currencyType = this.humName(pairAssets.exchB);
        exchangeRate = this.humName(pairAssets.exchA) + ' / ' + this.humName(pairAssets.exchB);
      }
    }

    if (filterParams.view === 'orders') {
      return (
        <div className="hl-head">
          <div>Order Type</div>
          <div>Date (UTC)</div>
          <div>Volume ({volumeType})</div>
          {/* <div>Currency ({currencyType})</div> */}
          <div>Price ({exchangeRate})</div>
          <div>Fee</div>
        </div>
      );
    }
    if (filterParams.view === 'automations') {
      return (
        <div className="hl-head">
          <div>Asset Bought</div>
          <div>Deposit Spent</div>
          <div>State</div>
        </div>
      );
    }
    return (null);
  }

  copyConfirm(address) {
    if (address) {
      if (document.getElementById(address)) {
        document.getElementById(address).className = "hl-i-copy-i c-i-success";
        setTimeout(() => {
          document.getElementById(address).className = "hl-i-copy-i";
        }, 200);
      }
    }
  }

  renderTable() {
    const { user, vhistory, ledger, getPairAssets, automationHistory } = this.props;
    const { filterParams, allSubHistory } = this.state;

    const isTransactions = filterParams.view !== 'trades' && filterParams.view !== 'orders' && filterParams.view !== 'transfers';
    let tableLoop;
    let subLoop;

    let payHandle;
    if (filterParams.handle) {
      payHandle = filterParams.handle.toLowerCase();
    }
    let useHistory = vhistory;
    if (isTransactions) {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        let address;
        let erc20;
        let assetConf;
        let histAsset;
        if (hist && hist.asset) {
          histAsset = hist.asset.toUpperCase();
        }
        if (AssetConfig && AssetConfig.length) {
          assetConf = AssetConfig.find((item) => item.handle === histAsset);
        }
        if (assetConf && assetConf.erc20) {
          erc20 = assetConf.erc20;
        }

        if (hist.subject) {
          address = hist.transactionReference;
        }
        let transactionUrl = 'https://live.blockcypher.com/' + payHandle + '/tx/' + address;
        if (erc20) {
          if (address && address.startsWith('0x')) {
            transactionUrl = 'https://etherscan.io/tx/' + address;
          } else {
            transactionUrl = 'https://etherscan.io/tx/0x' + address;
          }
        }

        return (
          <div className="hl-item" key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div style={{ textTransform: 'capitalize' }}>{hist.type}</div>
              <div>{hist.notes || ''}</div>
              <div>{hist.referenceId}</div>
              <div>{moment.unix(hist.createdAt).format(dateFormat)}</div>
              <div>{hist.value}</div>
              <div style={{ textTransform: 'capitalize' }}>{hist.status}</div>
              <CopyToClipboard
                text={address}
                onCopy={() => this.copyConfirm(address + index)}
              >
                <div className="hl-i-copy">
                  <div className="hl-i-copy-t">
                    {address}
                  </div>
                  <div className="hl-i-copy-i" id={address + index}>
                    <FontAwesomeIcon
                      icon={faCopy}
                      className={'copy-icon'}
                    />
                  </div>
                </div>
              </CopyToClipboard>
              <div>
                {histAsset === 'EUR' || histAsset === 'GBP' ? (
                  null
                ) : (
                  <a href={transactionUrl} target="_blank" rel="noopener noreferrer">View</a>
                )}
              </div>
            </div>
          </div>
        );
      });
    }
    if (filterParams.view === 'trades') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        return (
          <div className={
            hist.status === 'REVERSED' ?
              'hl-item ' + hist.status.toLowerCase()
              :
              'hl-item ' + hist.type.toLowerCase()
            }
            key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div style={{ textTransform: 'capitalize' }}>{hist.type}</div>
              <div>{moment.unix(hist.createdAt).format(dateFormat)}</div>
              <div>{hist.quantity}</div>
              {/* <div>{hist.currency}</div> */}
              <div>{hist.price}</div>
              <div style={{ textTransform: 'capitalize' }}>
                {hist.fees.value} {hist.fees.handle}
              </div>
              <div>{hist.status}</div>
            </div>
          </div>
        );
      });
    }
    if (filterParams.view === 'orders') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        const itemState = 'order' + index;

        let matchingSubs;
        if (allSubHistory && allSubHistory.length) {
          matchingSubs = allSubHistory.filter((item) => item.orderReferenceId === hist.referenceId);
        }

        subLoop = matchingSubs && matchingSubs.map((sub, index) => {
          return (
            <div className={'hl-item hl-sub-item ' + sub.type.toLowerCase()} key={index}>
              {this.subTableHeadings()}
              <div className="hl-i-inf">
                <div style={{textTransform: 'capitalize'}} >{sub.type}</div>
                <div>{moment.unix(sub.createdAt).format(dateFormat)}</div>
                <div>{sub.quantity}</div>
                {/* <div>{hist.currency}</div> */}
                <div>{sub.price}</div>
                <div style={{ textTransform: 'capitalize' }}>{sub.fees.value}</div>
              </div>
            </div>
          );
        });

        return (
          <div key={index}>
            <div className={'hl-item ' + hist.type.toLowerCase()}>
              {this.tableHeadings()}
              <div className="hl-i-inf">
                <div>{hist.status}</div>
                <div>{moment.unix(hist.createdAt).format(dateFormat)}</div>
                <div>{moment.unix(hist.updatedAt).format(dateFormat)}</div>
                <div>{hist.initialQuantity}</div>
                <div>{hist.quantity}</div>
                <div>{hist.value}</div>
                <div style={{ textTransform: 'capitalize' }}>{hist.type}</div>
                <div style={{ textTransform: 'capitalize' }}>{hist.matchType}</div>
                <div
                  style={{
                    fontWeight: 'bold',
                    textTransform: 'capitalize',
                    cursor: 'pointer',
                  }}
                  onClick={() => this.toggleOrderSub(itemState, hist.referenceId)}
                >
                  {this.state[itemState] ? 'Hide' : 'Show'}
                </div>
              </div>
            </div>
            {this.state[itemState] && (
              matchingSubs && matchingSubs.length ? (
                subLoop
              ) : (
                <div className={'hl-item hl-sub-item'}>
                  {this.subTableHeadings()}
                  <div className="hl-i-inf" style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <h3>No Trade Data</h3>
                  </div>
                </div>
              )
            )}
          </div>
        );
      });
    }
    if (filterParams.view === 'transfers') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        const histType = hist.type.replace(/_/g, ' ');
        let useHandle;
        if (hist.handle) {
          useHandle = this.humName(hist.handle);
        }
        let histDesc;

        if (hist.meta && hist.meta.description) {
          histDesc = hist.meta.description;
        } else {
          switch (hist.type) {
            case 'V1_CREDIT':
              histDesc = 'Balance from Vaultoro V1';
              break;
            case 'VOLUME30':
              histDesc = 'Trading fee';
              break;
            case 'REFERRAL_DIRECT':
              histDesc = 'Referral fee';
              break;
            case 'REFERRAL_INDIRECT':
              histDesc = 'Referral fee';
              break;
            case 'WITHDRAWAL_FEE':
              histDesc = 'Withdrawal fee';
              break;
            case 'REFERRAL_CREDIT':
              histDesc = 'Referral credit';
              break;
            case 'VAULT_FEE':
              histDesc = 'Storage fee';
              break;
            case 'DEPOSIT_FEE':
              histDesc = 'Deposit fee';
              break;
            default:
              histDesc = '';
          }
        }

        return (
          <div className="hl-item" key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div>{moment.unix(hist.createdAt).format(dateFormat)}</div>
              <div style={{ textTransform: 'capitalize' }}>{histType}</div>
              <div style={{ textTransform: 'capitalize' }}>{hist.status}</div>
              <div>{hist.value} {useHandle}</div>
              <div className="hl-i-inf-desc">{histDesc}</div>
            </div>
          </div>
        );
      });
    }
    // TRADES V2
    if (filterParams.view === 'trades-v2') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        let humPair;
        if (hist.pair) {
          if (filterParams.exchange === 'GOLDDASH') {
            humPair = 'GOLD/DASH';
          }
          if (filterParams.exchange === 'DASHBTC') {
            humPair = 'DASH/BTC';
          }
          if (filterParams.exchange === 'GOLDBTC') {
            humPair = 'GOLD/BTC';
          }
          if (filterParams.exchange === 'SILVERBTC') {
            humPair = 'SILVER/BTC';
          }
        }
        let feeNegative;
        if (hist.fees.value < 0) {
          feeNegative = true;
        }

        return (
          <div className={'hl-item ' + hist.type.toLowerCase()} key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div>{hist.referenceId}</div>
              <div></div>
              <div>{humPair}</div>
              <div>{hist.price}</div>
              <div>{hist.quantity}</div>
              <div></div>
              <div style={feeNegative ? { color: 'rgb(78, 199, 138)' } : null}>
                {hist.fees.value}
                <span style={{ textTransform: 'capitalize' }}> {hist.fees.handle}</span>
              </div>
              <div></div>
              <div>{hist.type}</div>
            </div>
          </div>
        );
      });
    }
    // ORDERS V2
    if (filterParams.view === 'orders-v2') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        let itemState = 'order' + index;
        let matchingSubs;
        if (allSubHistory && allSubHistory.length) {
          matchingSubs = allSubHistory.filter(function(item) {
            return item.orderReferenceId === hist.referenceId;
          });
        }
        let humPair;
        if (hist.pair) {
          let pairAssets;
          if (filterParams.exchange) {
            pairAssets = getPairAssets(filterParams.exchange);
            if (pairAssets && pairAssets.exchA && pairAssets.exchB) {
              humPair = this.humName(pairAssets.exchA) + ' / ' + this.humName(pairAssets.exchB);
            }
          }
        }

        subLoop = matchingSubs && matchingSubs.map((sub, index) => {
          return (
            <div className={'hl-item hl-sub-item ' + sub.type.toLowerCase()} key={index}>
              {this.subTableHeadings()}
              <div className="hl-i-inf">
                <div style={{ textTransform: 'capitalize' }}>{sub.type}</div>
                <div>{moment.unix(sub.createdAt).format(dateFormat)}</div>
                <div>{sub.quantity}</div>
                {/* <div>{hist.currency}</div> */}
                <div>{sub.price}</div>
                <div style={{ textTransform: 'capitalize' }}>{sub.fees.value}</div>
              </div>
            </div>
          );
        });

        return (
          <div key={index}>
            <div className={'hl-item ' + hist.type.toLowerCase()}>
              {this.tableHeadings()}
              <div className="hl-i-inf">
                <div>{hist.referenceId}</div>
                <div></div>
                <div>{humPair}</div>
                <div>{hist.value}</div>
                <div></div>
                <div>{hist.initialQuantity - hist.quantity}</div>
                <div></div>
                <div>{hist.type}</div>
                <div>{hist.status}</div>
              </div>
            </div>
            {this.state[itemState] && (
              matchingSubs && matchingSubs.length ? (
                subLoop
              ) : (
                <div className={'hl-item hl-sub-item'}>
                  {this.subTableHeadings()}
                  <div className="hl-i-inf" style={{alignItems: 'center', justifyContent: 'center'}}>
                    <h3>No Trade Data</h3>
                  </div>
                </div>
              )
            )}
          </div>
        );
      });
    }
    // TRANSFERS V2
    if (filterParams.view === 'transfers-v2') {
      tableLoop = vhistory && vhistory.map((hist, index) => {
        const histType = hist.type.replace(/_/g, ' ');
        let useHandle;
        if (hist.handle) {
          useHandle = this.humName(hist.handle);
        }

        let histDesc;

        if (hist.meta && hist.meta.description) {
          histDesc = hist.meta.description;
        } else {
          switch (hist.type) {
            case 'V1_CREDIT':
              histDesc = 'Balance from Vaultoro V1';
              break;
            case 'VOLUME30':
              histDesc = 'Trading fee';
              break;
            case 'REFERRAL_DIRECT':
              histDesc = 'Referral fee';
              break;
            case 'REFERRAL_INDIRECT':
              histDesc = 'Referral fee';
              break;
            case 'WITHDRAWAL_FEE':
              histDesc = 'Withdrawal fee';
              break;
            case 'REFERRAL_CREDIT':
              histDesc = 'Referral credit';
              break;
            case 'VAULT_FEE':
              histDesc = 'Storage fee';
              break;
            default:
              histDesc = '';
          }
        }

        return (
          <div className="hl-item" key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div>{moment.unix(hist.createdAt).format(dateFormat)}</div>
              <div style={{ textTransform: 'capitalize' }}>{histType}</div>
              <div style={{ textTransform: 'capitalize' }}>{hist.status}</div>
              <div>{hist.value} {useHandle}</div>
              <div className="hl-i-inf-desc">{histDesc}</div>
            </div>
          </div>
        );
      });
    }
    // LEDGER
    if (filterParams.view === 'ledger') {
      useHistory = ledger;
      tableLoop = ledger && ledger.map((item, index) => {
        let useType = item.typeHandle;
        if (item.typeHandle === 'TRANSFER' || item.typeHandle === 'transfer') {
          useType = 'FEE';
        }
        return (
          <div className="hl-item" key={index}>
            {this.tableHeadings()}
            <div className="hl-i-inf">
              <div>{item.referenceId}</div>
              <div>{moment.unix(item.createdAt).format(dateFormat)}</div>
              <div>{moment.unix(item.createdAt).unix()}</div>
              <div>{useType}</div>
              <div>{item.handle}</div>
              <div>{item.value}</div>
              <div>{item.runningTotal}</div>
            </div>
          </div>
        );
      });
    }

    if (filterParams.view === 'statements') {
      let createdAt;
      let signupMonth;
      let signupYear;
      if (user && user.me && user.me.createdAt) {
        createdAt = user.me.createdAt;
      }
      if (createdAt) {
        signupMonth = moment.unix(createdAt).month()
        signupYear = moment.unix(createdAt).year()
      }

      const years = getFullYearsArray();

      const nowYear = moment().year();
      const nowMonth = moment().month() + 1;

      let minYear;
      let minMonth;
      let maxYear;
      let maxMonth;

      const stateMinDate = moment().subtract(36, 'months').unix();

      if (stateMinDate) {
        minMonth = moment.unix(stateMinDate).month() + 1;
        minYear = moment.unix(stateMinDate).year();
      }

      let useYears;
      if (years && signupYear) {
        useYears = years.filter((item) => {
          return item >= signupYear;
        });
        if (nowYear) {
          useYears = useYears.filter((item) => {
            return item <= nowYear;
          });
        }
        if (minYear) {
          useYears = useYears.filter((item) => {
            return item >= minYear;
          });
        }
        if (maxYear) {
          useYears = useYears.filter((item) => {
            return item <= maxYear;
          });
        }
        if (useYears && useYears.length) {
          useYears = useYears.reverse();
        }
      }

      let useStatements;
      if (useYears && months) {
        useStatements = useYears && useYears.length && useYears.map((year, index) => {
          let useMonths = months;
          if (year === signupYear) {
            useMonths = useMonths.filter((item) => {
              return item.key >= signupMonth;
            });
          }
          if (year === nowYear) {
            if (nowMonth) {
              useMonths = useMonths.filter((item) => {
                return item.key < nowMonth;
              });
            }
          }
          if (year === minYear) {
            if (minMonth) {
              useMonths = useMonths.filter((item) => {
                return item.key >= minMonth;
              });
            }
          }
          if (year === maxYear) {
            if (maxMonth) {
              useMonths = useMonths.filter((item) => {
                return item.key <= maxMonth;
              });
            }
          }
          if (useMonths && useMonths.length) {
            useMonths = useMonths.reverse();
          }
          return {
            year,
            months: useMonths
          }
        });
      }

      tableLoop = <h3 className="no-data">No Data</h3>;

      if (useStatements && useStatements.length > 0) {
        tableLoop = useStatements && useStatements.map((date, index) => {
          const statementLoop = date.months.map(month => (
            <div className="hl-item" key={`state-${month.key + 1}`}>
              {this.tableHeadings()}
              <div className="hl-i-inf">
                <div>{month.label} {date.year}</div>
                <div>
                  <span onClick={() => this.getStatement(month.key, date.year)} style={{cursor: 'pointer'}}>
                    <b>Download</b>
                  </span>
                </div>
              </div>
            </div>
          ));
          return (
            statementLoop
          );
        });
      }
    }

    if (filterParams.view === 'automations') {
      tableLoop = automationHistory && automationHistory.map((hist, index) => {
        let flowId;
        let referenceId;
        let createdAt;
        let purchaseResults = [];
        let depositAsset;

        if (hist && hist.flowId) {
          flowId = hist.flowId;
        }
        if (hist && hist.referenceId) {
          referenceId = hist.referenceId;
        }
        if (hist && hist.createdAt) {
          createdAt = hist.createdAt;
        }
        if (hist && hist.meta && hist.meta.purchaseResults && hist.meta.purchaseResults.length) {
          purchaseResults = hist.meta.purchaseResults;
        }
        if (hist && hist.meta && hist.meta.depositAsset) {
          depositAsset = hist.meta.depositAsset;
        }

        const itemState = 'automation' + index;

        subLoop = purchaseResults && purchaseResults.map((sub, index) => {
          let asset;
          let percentage;
          let successful;

          if (sub.asset) {
            asset = sub.asset;
          }
          if (sub.percentage) {
            percentage = sub.percentage;
          }
          if (sub.successful) {
            successful = sub.successful;
          }

          let successClass = ' hl-fail';
          if (successful) {
            successClass = ' hl-succ'
          }

          return (
            <div className={'hl-item hl-sub-item' + successClass} key={index}>
              {this.subTableHeadings()}
              <div className="hl-i-inf">
                <div>{asset}</div>
                <div>{percentage ? percentage + '%' : ''}</div>
                <div>{successful ? ('Successful') : ('Unsuccessful')}</div>
              </div>
            </div>
          );
        });

        let hasFail;
        let hasSuccess;
        if (purchaseResults && purchaseResults.length) {
          hasFail = purchaseResults.find((item) => {
            return item.successful === false;
          });
          hasSuccess = purchaseResults.find((item) => {
            return item.successful === true;
          });
        }

        let successClass = '';
        if (hasFail && !hasSuccess) {
          successClass = ' fail';
        }
        if (!hasFail && hasSuccess) {
          successClass = ' success';
        }
        if (hasFail && hasSuccess) {
          successClass = ' partial';
        }

        return (
          <div key={index}>
            <div className={'hl-item' + successClass}>
              {this.tableHeadings()}
              <div className="hl-i-inf">
                <div>{flowId}</div>
                <div>{referenceId}</div>
                <div>{moment(hist.createdAt).format(dateFormat)}</div>
                <div>{depositAsset}</div>
                <div
                  style={{
                    fontWeight: 'bold',
                    textTransform: 'capitalize',
                    cursor: 'pointer',
                  }}
                  onClick={() => this.toggleAutomationSub(itemState, hist.referenceId)}
                >
                  {this.state[itemState] ? 'Hide' : 'Show'}
                </div>
              </div>
            </div>
            {this.state[itemState] && (
              purchaseResults && purchaseResults.length ? (
                subLoop
              ) : (
                <div className={'hl-item hl-sub-item'}>
                  {this.subTableHeadings()}
                  <div className="hl-i-inf" style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <h3>No Automation Trade Data</h3>
                  </div>
                </div>
              )
            )}
          </div>
        );
      });
    }

    return (
      <div className="history-list">
        {this.tableHeadings()}
        <div className="hl-items-con">
          {tableLoop && tableLoop.length ? (
            tableLoop
          ) : (
            <h3 className="no-data">No Data</h3>
          )}
        </div>
      </div>
    );
  }

  isOfType(asset, type) {
    let useAsset;
    if (asset) {
      useAsset = asset.toUpperCase();
    }
    let useType;
    if (type) {
      useType = type.toUpperCase();
    }
    let typeAssets;
    let isType;
    if (AssetConfig && AssetConfig.length) {
      typeAssets = AssetConfig.filter((item) => {
        return item.type === useType;
      });
    }
    if (typeAssets && typeAssets.length) {
      isType = typeAssets.find((item) => {
        return item.handle === useAsset;
      });
    }
    if (isType) {
      return true;
    }
    return false;
  }

  handlePair(pair) {
    const { pairs, assets } = this.props;
    const { historyPairs, otcAssets } = this.state;
    const usePair = pair[0] + pair[1];
    const revPair = pair[1] + pair[0];
    let tradeType;

    let historyPair;
    if (historyPairs && Object.keys(historyPairs).length) {
      historyPair = historyPairs[usePair];
      if (historyPair) {
        tradeType = 'BUY';
      }
    }
    if ((historyPairs && Object.keys(historyPairs).length) && !historyPair) {
      historyPair = historyPairs[revPair];
      if (historyPair) {
        tradeType = 'SELL';
      }
    }
    let returnPair;
    if (historyPair && tradeType) {
      if (tradeType === 'BUY') {
        returnPair = usePair;
      }
      if (tradeType === 'SELL') {
        returnPair = revPair;
      }
    }
    return returnPair;
  }

  handleSplitPair(event, field) {
    const { history } = this.props;
    let { filterParams, pairA, pairB } = this.state;
    const { value } = event.target;
    let pairCombine;
    let exchangePair;
    let useA = pairA;
    let useB = pairB;
    if (value && field) {
      if (field === 'pairA') {
        useA = value;
        if (value === 'DASH') {
          useB = 'BTC';
        }
      }
      if (field === 'pairB') {
        useB = value;
        if (useA === 'DASH') {
          useA = 'GOLD';
        }
        if (value === 'DASH') {
          useA = 'GOLD';
        }
      }
      filterParams[field] = value;
      pairCombine = [useA.toUpperCase(), useB.toUpperCase()];
      exchangePair = this.handlePair(pairCombine);
      filterParams['exchange'] = exchangePair;
    }
    this.setState({ filterParams, pairA: useA, pairB: useB });
    history.push({ search: '?' + qs.stringify(filterParams) });
    this.updateData(1, filterParams);
  }

  generateStatement() {
    const { dispatch } = this.props
    const { month, year, recaptchaRef } = this.state;
    const recaptchaValue = recaptchaRef.current.getValue();
    const requestParams = {
      month,
      year,
      type: 'MONTHLY_STATMENTS',
      captcha: recaptchaValue,
    }
    dispatch(requestGenerateStatement(requestParams))
      .then((res) => {
        if (res.type === 'GENERATE_STATEMENT_SUCCESS') {
          // this.props.toggleModal(null);
        }
      });
  }

  getStatement(month, year) {
    this.setState({
      month,
      year,
    });
    this.onSubmitWithReCAPTCHA();
  }

  render() {
    const { vhistory, histPagination, automationHistoryPagination, errors, success, ledger, ledgerPagination, enabledPairs, enabledAssets, assets, getPairAssets } = this.props;
    let { filterParams, exported, loading, currentPage, pairA, pairB, statement, month, year, recaptchaRef } = this.state;

    let exportDisabled = !vhistory || (vhistory.length < 1) || exported;

    if (filterParams.view === 'ledger') {
      exportDisabled = !ledger || (ledger.length < 1) || exported;
    }

    const histViews = [
      {
        label: 'Transactions',
        value: 'transactions',
      },
      {
        label: 'Trades',
        value: 'trades',
      },
      {
        label: 'Orders',
        value: 'orders',
      },
      {
        label: 'Fees & Credits',
        value: 'transfers',
      },
      {
        label: 'Ledger',
        value: 'ledger',
      },
      {
        label: 'Statements',
        value: 'statements',
      },
      {
        label: 'Automations',
        value: 'automations',
      },
    ];

    const viewLoop = histViews && histViews.map((asset, index) => {
      return (
        <option value={asset.value} key={index}>{asset.label}</option>
      );
    });

    let exchangePairs = [];
    let assetList = [];

    if (enabledPairs && enabledPairs.length) {
      exchangePairs = enabledPairs.map((pair) => {
        const pairAssets = getPairAssets(pair);
        let humPair;
        if (pairAssets && pairAssets.exchA && pairAssets.exchB) {
          humPair = this.humName(pairAssets.exchA) + ' / ' + this.humName(pairAssets.exchB);
        }
        return ({
          value: pair,
          label: humPair,
        })
      });
    }

    let exchAList;
    let exchBList;
    let useDash;
    if (enabledAssets && enabledAssets.length) {
      exchAList = enabledAssets.filter((asset) => asset !== pairB);
      exchBList = enabledAssets.filter((asset) => {
        return (
          asset !== pairA
        );
      });
      if (exchAList && exchAList.length) {
        exchAList = exchAList.map((asset) => {
          const humAsset = this.humName(asset);
          return ({
            value: asset,
            label: humAsset,
          });
        });
        exchAList.sort(function(a, b){
          var nameA = a.label.toLowerCase(), nameB = b.label.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
      if (exchBList && exchBList.length) {
        exchBList = exchBList.map((asset) => {
          const humAsset = this.humName(asset);
          return ({
            value: asset,
            label: humAsset,
          });
        });
        exchBList.sort(function(a, b){
          var nameA = a.label.toLowerCase(), nameB = b.label.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    }

    if (enabledAssets && enabledAssets.length) {
      assetList = enabledAssets.map((asset) => {
        const humAsset = this.humName(asset);
        return ({
          value: asset,
          label: humAsset,
        });
      });

      if (assetList && assetList.length) {
        assetList.sort(function(a, b){
          var nameA = a.label.toLowerCase(), nameB = b.label.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    }

    const pairALoop = exchAList && exchAList.map((asset, index) => {
      return (
        <option value={asset.value} key={index}>{asset.label}</option>
      );
    });
    const pairBLoop = exchBList && exchBList.map((asset, index) => {
      return (
        <option value={asset.value} key={index}>{asset.label}</option>
      );
    });

    const exchangePairsLoop = exchangePairs && exchangePairs.map((pair, index) => {
      return (
        <option value={pair.value} key={index}>{pair.label}</option>
      );
    });
    const assetListLoop = assetList && assetList.map((pair, index) => {
      return (
        <option value={pair.value} key={index}>{pair.label}</option>
      );
    });

    let transactionAssets = [];
    if (assetList && assetList.length) {
      transactionAssets = assetList.filter((item) => {
        return (
          item.value !== 'VEUR' && item.value !== 'VGBP'
        );
      });
    }

    const transactionAssetsLoop = transactionAssets && transactionAssets.map((item, index) => {
      return (
        <option value={item.value} key={index}>{item.label}</option>
      );
    });


    if (loading) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    if (filterParams.view === 'trades' || filterParams.view === 'trades-v2') {
      return (
        <div className="grid-x history">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
              <div className="f-sp">
                <select value={pairA} onChange={(e) => this.handleSplitPair(e, 'pairA')}>
                  {pairALoop}
                </select>
                <span>
                  /
                </span>
                <select value={pairB} onChange={(e) => this.handleSplitPair(e, 'pairB')}>
                  {pairBLoop}
                </select>
              </div>
              <select id="type" value={filterParams.type} onChange={(e) => this.handleChange(e, 'type')}>
                <option value="ALL">All</option>
                <option value="BUY">Buy</option>
                <option value="SELL">Sell</option>
              </select>
              {this.showCalendar()}
            </div>
            <button type="button" className="export" onClick={() => this.exportData()} disabled={exported}>
              <SvgExportIcon />
              <span>Export</span>
            </button>
          </div>
          {this.renderTable()}
          {histPagination ? (
            <Pagination
              rowsPerPage={histPagination.limit || 100}
              totalRows={histPagination.count || 0}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
          ) : ( null ) }
        </div>
      );
    }

    if (filterParams.view === 'orders' || filterParams.view === 'orders-v2') {
      return (
        <div className="grid-x history">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
              <div className="f-sp">
                <select value={pairA} onChange={(e) => this.handleSplitPair(e, 'pairA')}>
                  {pairALoop}
                </select>
                <span>
                  /
                </span>
                <select value={pairB} onChange={(e) => this.handleSplitPair(e, 'pairB')}>
                  {pairBLoop}
                </select>
              </div>
              <select id="type" value={filterParams.type} onChange={(e) => this.handleChange(e, 'type')}>
                <option value="ALL">All</option>
                <option value="BUY">Buy</option>
                <option value="SELL">Sell</option>
              </select>
              <select id="type" value={filterParams.type} onChange={(e) => this.handleChange(e, 'status')}>
                <option value="ANY">Any</option>
                <option value="OPEN">Open</option>
                <option value="FILLED">Filled</option>
                <option value="CANCELLED">Cancelled</option>
              </select>
              {/* {this.showCalendar()} */}
            </div>
            <button type="button" className="export" onClick={() => this.exportData()} disabled={exported}>
              <SvgExportIcon />
              <span>Export</span>
            </button>
          </div>
          {this.renderTable()}
          {histPagination ? (
            <Pagination
              rowsPerPage={histPagination.limit || 100}
              totalRows={histPagination.count || 0}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
          ) : ( null )}
        </div>
      );
    }

    if (filterParams.view === 'transfers' || filterParams.view === 'transfers-v2') {
      return (
        <div className="grid-x history">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
              {this.showCalendar()}
            </div>
            <button type="button" className="export" onClick={() => this.exportData()} disabled={exported}>
              <SvgExportIcon />
              <span>Export</span>
            </button>
          </div>
          {this.renderTable()}
          {histPagination ? (
            <Pagination
              rowsPerPage={histPagination.limit || 100}
              totalRows={histPagination.count || 0}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
          ) : ( null ) }
        </div>
      );
    }

    if (filterParams.view === 'ledger') {
      return (
        <div className="grid-x history">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
              <select id="handle" value={filterParams.handle} onChange={(e) => this.handleChange(e, 'handle')}>
                <option value="ALL">ALL</option>
                {assetListLoop}
              </select>
              {this.showCalendar()}
            </div>
            <button type="button" className="export" onClick={() => this.exportData()} disabled={exported}>
              <SvgExportIcon />
              <span>Export</span>
            </button>
          </div>
          <small style={{ marginBottom: 8 }}>
            Ledger is currently in BETA; if you think there is an issue please contact support.
          </small>
          {this.renderTable()}
          {ledgerPagination ? (
            <Pagination
              rowsPerPage={ledgerPagination.limit || 100}
              totalRows={ledgerPagination.count || 0}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
          ) : ( null ) }
        </div>
      );
    }

    if (filterParams.view === 'statements') {
      return (
        <div className="grid-x history">
          <Recaptcha
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            onChange={this.generateStatement}
            size="invisible"
            onExpired={() => {}}
            onErrored={(e) => {
              this.showError(e);
            }}
          />
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
            </div>
          </div>
          {this.renderTable()}
        </div>
      );
    }

    if (filterParams.view === 'automations') {
      return (
        <div className="grid-x history">
          <ToastHandler errors={errors} success={success} />
          {this.state.modalComponent && (
            <Modal
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <div className="cell small-12 medium-12 large-12 filters-wrapper">
            <div className="filters">
              <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
                {viewLoop}
              </select>
            </div>
          </div>
          {this.renderTable()}
          {automationHistoryPagination ? (
            <Pagination
              rowsPerPage={automationHistoryPagination.limit || 100}
              totalRows={automationHistoryPagination.count || 0}
              setCurrentPage={this.setCurrentPage}
              currentPage={currentPage}
            />
          ) : ( null ) }
        </div>
      );
    }

    return (
      <div className="grid-x history">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent && (
          <Modal
            toggleModal={this.toggleModal}
            modalComponent={this.state.modalComponent}
          />
        )}
        <div className="cell small-12 medium-12 large-12 filters-wrapper">
          <div className="filters">
            <select id="view" value={filterParams.view} onChange={(e) => this.handleChange(e, 'view')}>
              {viewLoop}
            </select>
            <select id="paymentMethod" value={filterParams.handle} onChange={(e) => this.handleChange(e, 'handle')}>
              {transactionAssetsLoop}
            </select>
            <select id="type" value={filterParams.type} onChange={(e) => this.handleChange(e, 'type')}>
              <option value="ALL">All</option>
              <option value="RECEIVE">Withdraw</option>
              <option value="SEND">Deposit</option>
            </select>
            {this.showCalendar()}
          </div>
          <button type="button" className="export" onClick={() => this.exportData()} disabled={exported}>
            <SvgExportIcon />
            <span>Export</span>
          </button>
        </div>
        {this.renderTable()}
        {histPagination ? (
          <Pagination
            rowsPerPage={histPagination.limit || 100}
            totalRows={histPagination.count || 0}
            setCurrentPage={this.setCurrentPage}
            currentPage={currentPage}
          />
        ) : ( null ) }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.history.errors,
  success: state.history.success,
  vhistory: state.history.history,
  histPagination: state.history.pagination,
  subHistory: state.history.subHistory,
  subPagination: state.history.subPagination,
  ledger: state.ledger.ledger,
  ledgerPagination: state.ledger.pagination,
  automationHistory: state.automation.logs,
  automationHistoryPagination: state.automation.pagination,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(History));
